import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

export function MobileMenu({ isOpen, onToggle }) {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className="md:hidden hover:bg-gray-100"
      aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
    >
      {isOpen ? <X size={24} /> : <Menu size={24} />}
    </Button>
  );
}